import React from "react";
import moment from "moment";
import YoungHousehold from "./assets/bfile-life-stage-2.png";
import EmergingAdult from "./assets/bfile-life-stage-1.png";
import EstablishedHousehold from "./assets/bfile-life-stage-3.png";
import MatureHousehold from "./assets/bfile-life-stage-4.png";
import Retiree from "./assets/bfile-life-stage-5.png";
import { Card, message } from "antd";
import F from "./Functions";
import {
  AGENCY_NAME_IS_REQUIRED,
  CARD_HISTORY_TYPE,
  CSV_COLUMNS,
  CSV_FORM_FIELDS,
  EA,
  EMAIL_ADDRESS_IS_INVALID,
  EMAIL_IS_REQUIRED,
  INTELLIGENCE_LINK_COMPLETED,
  FOLLOW_UP_SPECIALIST,
  INTERNAL,
  INTERNAL_RAC_COMPLETED_BY_AGENCY,
  LIFE_OPPORTUNITIES,
  PHONE_NUMBER_COPIED_TO_CLIPBOARD,
  PROFILE_PDF_HEADERS,
  RETIREMENT_ASSETS_UNCOVERED,
  REVIEWSCHEDULER,
  REVIEW_SCHEDULER,
  SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN,
  SUB_TYPE_OF_CALL,
  TOTAL_ASSETS_UNCOVERED,
  TOTAL_P_AND_C_ITEMS,
  TYPE_OF_CALL,
  UMBRELLA_RECOMMENDED,
  UTC,
  VONBOARDER,
  VONSCHEDULER,
  get_label_from_value,
  shortTZMap,
  type_of_call_format,
  tzMap
} from "./utils/Constants";
import DataHandler from "./utils/DataHandler";
import { useBoundStore } from "./store/useBoundStore";

const today = new Date();

const Functions = {
  translate: (text) => {
    if (
      text in window.translate_db &&
      window.translate_lang in window.translate_db[text]
    ) {
      return window.translate_db[text][window.translate_lang];
    } else {
      return text;
    }
  },


  getDefaultDateRange: () => {
    const agencyCreatedDate = useBoundStore.getState().AgencyInfo.created_on;

    return {
      start_date: agencyCreatedDate
        ? moment(agencyCreatedDate).format("YYYY-MM-DD")
        : "2010-01-01", // fallback
      end_date: moment().format("YYYY-MM-DD"),
    };
  },


  getOldestAgency: (agencies) => {
    if (!agencies || agencies.length === 0) return null;

    return agencies.reduce((oldest, current) => {
      const currDate = moment(current.start_date || '2010-01-01');
      const oldDate = moment(oldest.start_date || '2010-01-01');

      return currDate.isBefore(oldDate) ? current : oldest;
    });
  },

  getYears: () => {
    const years = Array.from({ length: 41 }, (_, i) => 2010 + i);
    return years;
  },


  getMomentMonths: () => {
    const months = moment.months();
    return months;
  },






  // formatToLocal (utcTime) {
  //   if (!utcTime) return "—";

  //   const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   return moment
  //     .utc(utcTime)          // treat input as UTC
  //     .tz(userTimeZone)      // convert to user's timezone
  //     .format("hh:mm A, DD MMM YYYY z"); // formatted output
  // },


  formatToLocal(utcTime) {
    if (!utcTime) return "—";

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const utcDateTime = moment.utc(
      moment().format("YYYY-MM-DD") + " " + utcTime,
      "YYYY-MM-DD HH:mm:ss"
    );

    return utcDateTime
      .tz(userTimeZone)
      .format("hh:mm A z");
  },


  formatAppointmentTime(appointmentDate, customerTimezone) {
    if (!appointmentDate) return '-';

    const date = new Date(appointmentDate);
    const tz = tzMap[customerTimezone] || UTC;

    try {
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: tz,
        timeZoneName: tz !== UTC ? 'short' : undefined,
      };

      let timeString = date.toLocaleTimeString('en-US', options);

      if (shortTZMap[tz]) {
        timeString = timeString.replace(/GMT[-+]\d+/, shortTZMap[tz]);
      }

      return tz === UTC ? `${timeString} ${UTC}` : timeString;
    } catch (e) {
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: UTC,
      }) + ` ${UTC}`;
    }
  },


  getErrorMessage: (res) => {
    if (res && res.data && res.data.error_response) {
      var msg = res.data.error_response;
      if (msg.length > 250) {
        return msg.slice(0, 250) + '...';
      }
      return msg;
    }
    return SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN;
  },


  getNotesType: () => {
    let userType = useBoundStore.getState().userInfo.user_type;
    let defaultToggleUserRole = useBoundStore.getState().RSFSCardFilters.defaultToggleUserRole;
    let notesType;
    if (userType == REVIEWSCHEDULER || defaultToggleUserRole == REVIEWSCHEDULER) {
      notesType = REVIEW_SCHEDULER;
    } else if (userType == VONBOARDER || defaultToggleUserRole == VONBOARDER) {
      notesType = FOLLOW_UP_SPECIALIST;
    } else {
      notesType = INTERNAL;
    }
    return notesType;
  },


  getMonthNames: () => {
    return [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  }
  ,

  getFullName: (firstName, lastName) => {
    return `${firstName} ${lastName}`;
    },

  getMonthFromDate: (dateString, type) => {
    if (!dateString && type === 'RS') return "No Review";
    else if (!dateString && type === 'FS') return "-";
    return type === 'FS'
      ? moment.utc(dateString).format("MMMM")
      : moment(dateString).format("MMMM");
  },

  getAgenciesState : () => {
    return [
      {
        id : "true",
        name : "Active"
      },{
        id : "false",
        name : 'Inactive'
      }
    ]

  },

  getCarriers: () => {
    return [
      {
        id: "All Carrier",
        name: "All Carrier"
      },
      {
        id: "Allstate",
        addOnId: "price_1Q8Tf42DVWmKiFC59VrZZxGL",
        name: "Allstate",
      },
      {
        id: "Farmers",
        addOnId: "price_1Q8ThR2DVWmKiFC50R2gYpTI",
        name: "Farmers",
      },
      {
        id: "Country Financial",
        addOnId: "price_1Q8Th32DVWmKiFC5Xcxjag5n",
        name: "Country Financial",
      },
      {
        // id: "Farm Bureau-MI",
        id: "Farm Bureau",
        addOnId: "price_1Q8TfS2DVWmKiFC5q2OYB6J7",
        name: "Farm Bureau",
      },
      {
        id: "Independent Agent",
        addOnId: "price_1Q8Thp2DVWmKiFC5j0hu4muT",
        name: "Independent Agent",
      },
    ];
  },


  getMonths: () => {
    return [
      { id: "1", name: "January" },
      { id: "2", name: "February" },
      { id: "3", name: "March" },
      { id: "4", name: "April" },
      { id: "5", name: "May" },
      { id: "6", name: "June" },
      { id: "7", name: "July" },
      { id: "8", name: "August" },
      { id: "9", name: "September" },
      { id: "10", name: "October" },
      { id: "11", name: "November" },
      { id: "12", name: "December" }
    ];
  },



  getUserType: () => {
    return [
      { id: 'REVIEWSCHEDULER', name: 'RS' },
      { id: 'VONBOARDER', name: 'FS' },
      { id: 'VONSCHEDULER', name: 'RFS' }
    ];
  },

  getCompletedNonCompletedStatus: () => {
    return [
      { id: 'Complete', name: 'Complete' },
      { id: 'Not Complete', name: 'Not Complete' },
    ];
  },

  getTypeOFCall: () => {
    return [
      { id: 'Review', name: 'Review' },
      { id: 'Opportunity', name: 'Opportunity' },
      { id: 'Lead', name: 'Lead' }
    ];
  },

  getTypeOFCallCRM: () => {
    return [
      { id: 'Review', name: 'Review' },
      { id: 'FollowUp', name: 'Opportunity' },
      { id: 'Prospect', name: 'Lead' }
    ];
  },


  getSubTypeOptionsByRole: (role) => {
    if (role === REVIEWSCHEDULER) {
      return [
        { id: 'P&C Review', name: 'P&C Review' },
        { id: 'Life Insurance', name: 'Life Insurance Review' },
        { id: 'Commercial', name: 'Commercial/Farm' },
        { id: 'Retirement', name: 'Retirement' }
      ];
    } else {
      return [
        { id: 'Thank You / Referrals', name: 'Thank You / Referrals' },
        { id: 'Life Insurance', name: 'Life Insurance' },
        { id: 'Cross-Sell', name: 'P&C Cross-Sell' },
        { id: 'Commercial', name: 'Commercial/Farm' },
        { id: 'Retirement', name: 'Retirement' },
        { id: 'Re-Quote', name: 'New Quote/Re-Quote' },
        { id: 'Win Back', name: 'Win-Back' },
        { id: 'Event Call', name: 'Event Call' }
      ];
    }
    return [];
  },

  getLifeStage: () => {
    return [
      { id: "Emerging Adult", name: "Emerging Adult" },
      { id: "Young Household", name: "Young Household" },
      { id: "Established Household", name: "Established Household" },
      { id: "Mature Household", name: "Mature Household" },
      { id: "Retiree", name: "Retiree" }
    ];
  },



  handleGridReady(params, setGridApiOptions, excludeColumns) {
    setGridApiOptions({
      api: params.api,
      columnApi: params.columnApi,
    });
    const allColumnIds = params.columnApi
      .getAllColumns()
      .map(function (col) {
        return col.getColId();
      })
      .filter(function (id) {
        return !excludeColumns.includes(id);
      });

    setTimeout(function () {
      params.columnApi.autoSizeColumns(allColumnIds, false);
    });
  },




  transformCallTypeLabel: (text) => {
    switch (text) {
      case 'FollowUp':
        return 'Opportunity';
      case 'Prospect':
        return 'Lead';
      case 'Review':
        return 'Review';
      default:
        return text;
    }
  },



  handleCopyClick(phoneNumber) {
    navigator.clipboard.writeText(phoneNumber)
      .then(() => {
        message.success(PHONE_NUMBER_COPIED_TO_CLIPBOARD);
      })
      .catch((err) => {
        message.error('Failed to copy phone number');
      });
  },


  password_verify: ({ first_name = "", last_name = "", password = "" }) => {

    const escapeRegex = (string = "") => {
      string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const name_complexity_equirements = () => {
      const safeFirstName = escapeRegex(first_name.toLowerCase());
      const safeLastName = escapeRegex(last_name.toLowerCase());

      const regex = new RegExp(`${safeFirstName}|${safeLastName}`, "i");

      if (regex.test(password.toLowerCase())) {
        return false;
      }
      return true;
    };

    // const name_complexity_equirements = () => {
    //   const regex = new RegExp(first_name.toLowerCase() + "|" + last_name.toLowerCase(), "i");

    //   if (regex.test(password.toLowerCase())) {
    //     return false;
    //   }
    //   return true;
    // }


    const complexity_equirements = () => {

      // const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{};':\"|,.<>\/?]).{8,}$/;
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=[\]{};':\"|,.<>\/?])/;
      if (!regex.test(password)) {
        return false;
      }
      return true;
    }


    const password_length = () => {
      if (password && (password.length < 9 || password.length > 20)) {
        return false;
      }
      return true;
    }

    return { name_complexity_equirements, complexity_equirements, password_length }
  },

  // dollar_format: (val, toFixed) => {
  //   if (typeof toFixed === "undefined") toFixed = 0;
  //   // if (typeof val === typeof "" && val.includes("$")) return val
  //   if (typeof val === typeof "") return val
  //   if (typeof val !== "undefined") {
  //     let n = parseFloat(val);
  //     return (
  //       "$" +
  //       n.toFixed(toFixed).replace(/./g, function (c, i, a) {
  //         return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
  //       })
  //     );
  //   } else {
  //     return "";
  //   }
  // },

  dollar_format(val, toFixed) {
    if (typeof toFixed === "undefined") toFixed = 0;

    if (typeof val === "string" && val.includes("$")) return val;

    if (typeof val === "string") {
      const parts = val.split(/[^0-9.]/);
      if (parts.length > 1 || isNaN(parts[0])) return val;
    }

    if (typeof val !== "undefined" && !isNaN(val)) {
      let n = parseFloat(val);
      return (
        "$" +
        n.toFixed(toFixed).replace(/\B(?=(\d{3})+(?!\d))/g, ",") // NOSONAR
      );
    } else {
      return "";
    }
  },

  debounce: (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  },

  removeFormatterFromPhoneNumber: (phone) => {
    if (phone) {
      phone = phone.replace(" ", ""); // new add
      phone = phone.replace(/ /g, "");
      phone = phone.replace(/-/g, "");
      phone = phone.replace(/\(/g, "");
      phone = phone.replace(/\)/g, "");
      if (phone.length > 10) phone = phone.substring(0, 10);

      return phone;
    } else return ""
  },
  phone_format: (phone) => {
    if (typeof phone !== "undefined" && phone) {
      F.log("noor 1 " + phone);
      phone = phone.replace(" ", ""); // new add
      phone = phone.replace(/ /g, "");
      phone = phone.replace(/-/g, "");
      phone = phone.replace(/\(/g, "");
      phone = phone.replace(/\)/g, "");
      phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
      if (phone.length > 14) phone = phone.substring(0, 14);
      F.log("noor 2 " + phone);
      return phone;
    } else {
      return "";
    }
  },
  validatePhoneRegix: (phoneNumber) => {
    // F.log("Number-1 " + phoneNumber);

    phoneNumber = phoneNumber.replace(" ", ""); // new add
    phoneNumber = phoneNumber.replace(/ /g, "");
    phoneNumber = phoneNumber.replace(/-/g, "");
    phoneNumber = phoneNumber.replace(/\(/g, "");
    phoneNumber = phoneNumber.replace(/\)/g, "");
    // F.log("Number-2 " + phoneNumber);
    if (isNaN(phoneNumber)) {
      return false;
    }
    // const newPhoneNumber = F.phone_format(phoneNumber);
    // phoneNumber = phoneNumber.replace(/ /g, "");
    // phoneNumber = phoneNumber.replace(/-/g, "");
    // phoneNumber = phoneNumber.replace(/\(/g, "");
    // phoneNumber = phoneNumber.replace(/\)/g, "");
    const phoneRGEX = /(\d{3})(\d{3})(\d{4})/;
    const res = phoneRGEX.test(phoneNumber);
    //  F.log("Number-3 " + res);
    return res;
  },
  get_first_value: (str) => {
    if (typeof str !== "undefined" && str !== "" && str !== null) {
      str = str.replace(/\$/g, "");
      str = str.replace(/,/g, "");
      let arr = str.split("-");
      let num;
      if (arr.length > 1) {
        num = arr[0] * 1;
        return num;
      } else {
        arr = str.split("+");
        if (arr.length > 1) {
          num = arr[0] * 1;
          return num;
        }
      }
    }
    return 0;
  },
  get_second_value: (str) => {
    if (typeof str !== "undefined" && str !== "" && str !== null) {
      str = str.replace(/\$/g, "");
      str = str.replace(/,/g, "");
      let arr = str.split("-");
      let num;
      if (arr.length > 1) {
        num = arr[1] * 1;
        return num;
      } else {
        arr = str.split("+");
        if (arr.length > 1) {
          num = arr[0] * 1;
          return num;
        }
      }
    }
    return 0;
  },
  bfile_rac: (bfile) => {
    let rac = 0;
    let auto = 0;
    let home = 0;
    let financial = 0;
    let financial_spouse = 0;
    let income = 0;
    let income_spouse = 0;
    let customary_items = 0;
    // F.log("BFILE Intelligence Link =>", bfile);
    const get_second_value = (str) => {
      if (typeof str !== "undefined" && str !== "" && str !== null) {
        str = str.replace(/\$/g, "");
        str = str.replace(/,/g, "");
        let arr = str.split("-");
        let num;
        if (arr.length > 1) {
          num = arr[1] * 1;
          return num;
        } else {
          arr = str.split("+");
          if (arr.length > 1) {
            num = arr[0] * 1;
            return num;
          }
        }
      }
      return 0;
    };

    if (
      bfile.primary_vehicles_toggle === "1" &&
      bfile.primary_vehicles_num > 0
    ) {
      rac += bfile.primary_vehicles_num * 15000;
      auto += bfile.primary_vehicles_num * 15000;
    }

    if (bfile.secondary_vehicles_toggle === "1") {
      if (
        bfile.secondary_vehicles_value !== null &&
        bfile.secondary_vehicles_value !== ""
      ) {
        rac += get_second_value(bfile.secondary_vehicles_value);
        auto += get_second_value(bfile.secondary_vehicles_value);
      }
    }

    let mm;
    if (bfile.home_toggle === "1") {
      const home_market_value = get_second_value(bfile.home_market_value);
      if (bfile.home_market_value !== null && bfile.home_market_value !== "") {
        rac += home_market_value;
        home += home_market_value;
      }

      if (bfile.home_mortgage_toggle === "1") {
        mm = home_market_value - get_second_value(bfile.home_mortgage);
        if (mm >= 0) {
          rac -= home_market_value;
          home -= home_market_value;
          rac += mm;
          home += mm;
        } else {
          rac -= home_market_value;
          home -= home_market_value;
        }
      }
    }

    if (bfile.secondary_home_toggle === "1") {
      if (
        bfile.secondary_home_market_value !== null &&
        bfile.secondary_home_market_value !== ""
      ) {
        rac += get_second_value(bfile.secondary_home_market_value);
        home += get_second_value(bfile.secondary_home_market_value);
      }

      if (bfile.secondary_home_mortgage_toggle === "1") {
        mm =
          get_second_value(bfile.secondary_home_market_value) -
          get_second_value(bfile.secondary_home_mortgage);
        if (mm >= 0) {
          rac -= get_second_value(bfile.secondary_home_market_value);
          home -= get_second_value(bfile.secondary_home_market_value);
          rac += mm;
          home += mm;
        } else {
          rac -= get_second_value(bfile.secondary_home_market_value);
          home -= get_second_value(bfile.secondary_home_market_value);
        }
      }
    }

    if (bfile.personal_property_toggle === 1) {
      if (
        bfile.personal_property_value !== "" &&
        bfile.personal_property_value !== null
      ) {
        customary_items = get_second_value(bfile.personal_property_value);
        rac += get_second_value(bfile.personal_property_value);
        home += get_second_value(bfile.personal_property_value);
      }
    }

    if (
      bfile.employed_anual_income !== null &&
      bfile.employed_anual_income !== ""
    ) {
      // mm = get_second_value(bfile.employed_anual_income) * 0.5;
      mm = get_second_value(bfile.employed_anual_income);
      rac += mm;
      income += mm;
    }

    if (
      bfile.employed_anual_income_spouse !== null &&
      bfile.employed_anual_income_spouse
    ) {
      // mm = get_second_value(bfile.employed_anual_income_spouse) * 0.5;
      mm = get_second_value(bfile.employed_anual_income_spouse);
      rac += mm;
      // financial += mm;
      income_spouse += mm;
    }

    if (
      bfile.asset_preservation_value !== null &&
      bfile.asset_preservation_value !== ""
    ) {
      rac += get_second_value(bfile.asset_preservation_value);
      financial += get_second_value(bfile.asset_preservation_value);
    }

    if (
      bfile.asset_preservation_value_spouse !== null &&
      bfile.asset_preservation_value_spouse !== ""
    ) {
      rac += get_second_value(bfile.asset_preservation_value_spouse);
      // financial += get_second_value(bfile.asset_preservation_value_spouse)
      financial_spouse += get_second_value(bfile.asset_preservation_value_spouse);
    }

    if (bfile.asset_total_value !== null && bfile.asset_total_value !== "") {
      rac += get_second_value(bfile.asset_total_value);
      financial += get_second_value(bfile.asset_total_value);
    }

    if (
      bfile.asset_total_value_spouse !== null &&
      bfile.asset_total_value_spouse !== ""
    ) {
      rac += get_second_value(bfile.asset_total_value_spouse);
      // financial += get_second_value(bfile.asset_total_value_spouse);
      financial_spouse += get_second_value(bfile.asset_total_value_spouse);
    }

    F.log("B File ==>> " + JSON.stringify(bfile));

    return {
      rac: rac.toFixed(0),
      auto,
      home,
      financial,
      financial_spouse,
      income,
      income_spouse,
      customary_items
    };
  },
  bfile_status: (bfile) => {
    let status = bfile.status;

    if (bfile.is_saved_for_later === 1) {
      status = "Saved for Later";
    }

    bfile.items_sold = [];
    bfile.items_sold_length = 0;
    if (bfile.auto_sold_toggle === "1") {
      bfile.items_sold.push("Auto");
      bfile.items_sold_length++;
    }
    if (bfile.home_sold_toggle === "1") {
      bfile.items_sold.push("Home");
      bfile.items_sold_length++;
    }

    let ii, len;
    if (bfile.policies && bfile.policies.length > 0) {
      for (ii = 0, len = bfile.policies.length; ii < len; ii++) {
        let item = bfile.policies[ii].policy_type;
        if (bfile.policies[ii].policy_sold === 1) {
          bfile.items_sold.push(item);
          bfile.items_sold_length++;
        }
      }
    }
    if (bfile.financial_conversion && bfile.financial_conversion.length > 0) {
      if (
        bfile.financial_conversion[0].appointment_status === "Complete Sold"
      ) {
        let products_sold = bfile.financial_conversion[0].products_sold;
        let json = [];
        if (
          products_sold !== "" &&
          products_sold !== 0 &&
          products_sold !== null
        ) {
          json = JSON.parse(products_sold);
        }
        for (ii = 0, len = json.length; ii < len; ii++) {
          if (json[ii].product_sold !== "") {
            bfile.items_sold.push(json[ii].product_sold);
          }
        }
      }
    }

    if (bfile.is_onboarded) {
      status = "Sent for Internal Follow-Up";
    }
    if (bfile.questions && bfile.questions.length > 0) {
      if (
        bfile.questions[0].financial_conversion_action !== 0 &&
        bfile.questions[0].financial_conversion_action !== null &&
        bfile.questions[0].financial_conversion_action !== 3
      ) {
        status = "Sent for Follow-Up Call";
      }
      if (bfile.questions[0].financial_conversion_action === 2) {
        status = "Pending Financial Review";
      }
      if (bfile.questions[0].financial_conversion_action === 0) {
        status = "Renewal";
      }
    }
    if (bfile.vob_archived === 1) {
      status = "Not Interested in Follow-Up";
    } else {
      if (bfile.vonboard === 1) {
        status = "Sent for Virtual Follow-Up";
        if (bfile.vob_completed === 1) {
          status = "Sent for Follow-Up Call";
        }
      }
    }
    if (bfile.financial_id && bfile.financial_id !== null) {
      status = "Sent for Follow-Up Call";

      if (bfile.questions && bfile.questions.length > 0) {
        if (bfile.questions[0].financial_conversion_action === 2) {
          status = "Pending Financial Review";
        }
      }
    }
    if (bfile.financial_conversion && bfile.financial_conversion.length > 0) {
      if (
        bfile.financial_conversion[0].interested_in_appointment_toggle === "1"
      ) {
        status = "Financial Appointment Scheduled";
      }
      if (
        bfile.financial_conversion[0].appointment_status === "Complete Not Sold"
      ) {
        if (bfile.items_sold_length === 0) {
          status = "No Sale Archived";
        } else {
          status = "Renewal";
        }
      }
      if (
        bfile.financial_conversion[0].appointment_status === "Complete Sold"
      ) {
        if (bfile.items_sold_length === 0) {
          status = "No Sale Archived";
        } else {
          status = "Renewal";
        }
      }
      if (
        bfile.financial_conversion[0].appointment_status ===
        "Appointment Rescheduled"
      ) {
        status = "Appointment Rescheduled";
      }
      if (
        bfile.financial_conversion[0].appointment_status ===
        "Call to Reschedule"
      ) {
        status = "Call to Reschedule";
      }
      if (
        bfile.financial_conversion[0].appointment_status ===
        "Appointment Cancelled"
      ) {
        status = "Appointment Cancelled";
      }
    }
    if (bfile.archive === 1) {
      status = "No Sale Archived";
      if (bfile.items_sold.length > 0) {
        status = "Renewal";
      }
    }
    if (bfile.is_saved_for_later === 1) {
      status = "Saved for Later";
    }
    // return status;
    // return F.replaceNewBFileText(status);
    return F.replaceNewBFileText(status);
  },

  getAge: (birthday) => {
    if (!birthday) return null;
    let today = new Date();
    let thisYear = 0;
    if (today.getMonth() < birthday.getMonth()) {
      thisYear = 1;
    } else if (
      today.getMonth() === birthday.getMonth() &&
      today.getDate() < birthday.getDate()
    ) {
      thisYear = 1;
    }
    let age = today.getFullYear() - birthday.getFullYear() - thisYear;
    return age;
  },

  validDate: (date, split) => {
    if (!date || typeof date !== "string") return null;
    let dateString = date;
    let dataSplit = dateString.split(split);
    // if (dataSplit.length !== 3) return null;
    return new Date(dataSplit[2] + "/" + dataSplit[0] + "/" + dataSplit[1]);
  },


  bfile_items_sold: (bfile) => {
    let items_sold = [];
    if (bfile.auto_sold_toggle === "1") {
      items_sold.push("Auto");
    }
    if (bfile.home_sold_toggle === "1") {
      items_sold.push("Home");
    }
    if (bfile.policies && bfile.policies.length > 0) {
      for (let ii = 0; ii < bfile.policies.length; ii++) {
        let item = bfile.policies[ii].policy_type;
        if (bfile.policies[ii].policy_sold === 1) {
          items_sold.push(item);
        }
      }
    }
    if (bfile.financial_conversion && bfile.financial_conversion.length > 0) {
      if (
        bfile.financial_conversion[0].appointment_status === "Complete Sold"
      ) {
        let products_sold = bfile.financial_conversion[0].products_sold;
        let json = [];
        if (
          products_sold !== "" &&
          products_sold !== 0 &&
          products_sold !== null
        ) {
          json = JSON.parse(products_sold);
        }
        for (let ii = 0; ii < json.length; ii++) {
          if (json[ii].product_sold !== "") {
            items_sold.push(json[ii].product_sold);
          }
        }
      }
    }
    return items_sold;
  },
  bfile_items_not_sold: (bfile) => {
    let items_not_sold = [];
    if (bfile.auto_sold_toggle === "0") {
      items_not_sold.push("Auto");
    }
    if (bfile.home_sold_toggle === "0") {
      items_not_sold.push("Home");
    }
    if (bfile.policies && bfile.policies.length > 0) {
      for (let ii = 0; ii < bfile.policies.length; ii++) {
        let item = bfile.policies[ii].policy_type;
        if (bfile.policies[ii].policy_sold === 0) {
          items_not_sold.push(item);
        }
      }
    }
    return items_not_sold;
  },
  bfile_due_date: (bfile, user_default_date, ind = 0, user = null) => {
    /* 
       1- Only For VON-Dashboard
       2- For `Appointment Scheduled` & `Requested to be Re-Scheduled` List
      */
    if (
      user != null &&
      user.user_type === "VONBOARDER" &&
      (ind === 7 || ind === 8)
    ) {
      // get `von_appointment_date` which used on `Scheduled Appointment` for VON-Border
      const formatedDate = moment(bfile.von_appointment_date).format(
        "MM/DD/YYYY"
      );

      // check if It's past date --> change into red color
      if (
        moment(new Date(bfile.von_appointment_date)).add(1, "day") < moment()
      ) {
        return (
          <span
            style={{
              color: "red"
            }}
          >
            {formatedDate}
          </span>
        );
      } else {
        return formatedDate;
      }
    } else {
      let due_date = "-";
      let _due_date = "-";
      let due_date_late = false;

      if (
        (bfile.is_saved_for_later === 0 && bfile.questions.length === 0) ||
        (bfile.is_saved_for_later === 0 &&
          bfile.questions.length > 0 &&
          bfile.questions[0].financial_conversion_action === null)
      ) {
        due_date = _due_date = bfile.expiration_date;

        // comment this code
        // if (bfile.need_attention === 1) {
        //   due_date = _due_date = bfile.created_on;
        // }

        // below condition is only true when `expiration_date` is null
        if (
          (due_date === "" || due_date === null) &&
          bfile.need_attention === 1
        ) {
          due_date = _due_date = bfile.created_on;
        }

        due_date_late = false;
        if (due_date === "" || due_date === null) {
          if (user_default_date === null || user_default_date === 0) {
            user_default_date = 15;
          }
          due_date = moment(bfile.created_on)
            .add(user_default_date, "days")
            .format("MM/DD/YYYY");
          _due_date = moment(bfile.created_on)
            .add(user_default_date, "days")
            .format("MM/DD/YYYY");
        }

        if (moment(new Date(_due_date)).add(1, "day") < moment()) {
          //due_date = moment(new Date(_due_date)).add(1, 'day').fromNow(true)+" late";
          due_date = moment(new Date(_due_date)).format("MM/DD/YYYY");
          due_date_late = true;
        }
      }

      ind === 1 && F.log("due_date => " + due_date);

      if (due_date_late) {
        return <span style={{ color: "red" }}>{due_date}</span>;
      } else {
        if (due_date !== "-") {
          return moment(due_date).format("MM/DD/YYYY");
        } else if (
          bfile.expiration_date !== "" &&
          bfile.expiration_date !== null
        ) {
          return moment(bfile.expiration_date).format("MM/DD/YYYY");
        } else {
          return due_date;
        }
      }
    }
  },

  bfile_get_vonboarder_due_date: (bfile, ind, user_default_date) => {
    if (ind === 7 || ind === 8) {
      const formatedDate = moment(bfile.von_appointment_date).format(
        "MM/DD/YYYY"
      );

      // check if It's past date --> change into red color
      if (
        moment(new Date(bfile.von_appointment_date)).add(1, "day") < moment()
      ) {
        return (
          <span
            style={{
              color: "red"
            }}
          >
            {formatedDate}
          </span>
        );
      } else {
        return formatedDate;
      }
    } else {
      // expiration_date
      let expiration_date = bfile.expiration_date;

      // check if expiration_date null
      if (expiration_date === "" || expiration_date === null) {
        // use `created_on` date
        expiration_date = moment(bfile.created_on)
          .add(user_default_date, "days")
          .format("MM/DD/YYYY");
      }

      const formattedDate = moment(new Date(expiration_date));
      const cloneFormattedDate = moment(new Date(expiration_date));

      let isPastDate = cloneFormattedDate.add(1, "day") < moment();

      expiration_date = formattedDate.format("MM/DD/YYYY");

      if (isPastDate) {
        return <span style={{ color: "red" }}>{expiration_date}</span>;
      } else {
        return <span>{expiration_date}</span>;
      }
    }
  },
  bfile_get_vonboarder_appointment_date: (bfile, ind, user_default_date) => {
    if (ind === 7 || ind === 8) {
      const formattedDate = moment(bfile.von_appointment_date).format("MM/DD/YYYY");
      const isPastDate = moment(bfile.von_appointment_date).add(1, "day").isBefore(moment());

      return isPastDate
        ? <span style={{ color: "red" }}>{formattedDate}</span>
        : <span>{formattedDate}</span>;
    } else {
      let expiration_date = bfile.expiration_date;

      if (!expiration_date) {
        expiration_date = moment(bfile.created_on)
          .add(user_default_date, "days")
          .format("MM/DD/YYYY");
      }

      const formattedDate = moment(expiration_date, "MM/DD/YYYY");
      const isPastDate = formattedDate.clone().add(1, "day").isBefore(moment());

      return isPastDate
        ? <span style={{ color: "red" }}>{formattedDate.format("MM/DD/YYYY")}</span>
        : <span>{formattedDate.format("MM/DD/YYYY")}</span>;
    }
  }
  ,
  bfile_get_vonboarder_expiration_date: (bfile, ind, user_default_date) => {
    if (ind === 7 || ind === 8) {
      const formatedDate = moment(bfile.von_appointment_date).format(
        "MM/DD/YYYY"
      );

      // check if It's past date --> change into red color
      if (
        moment(new Date(bfile.von_appointment_date)).add(1, "day") < moment()
      ) {
        return (
          <span
            style={{
              color: "red"
            }}
          >
            {formatedDate}
          </span>
        );
      } else {
        return formatedDate;
      }
    } else {
      // expiration_date
      let expiration_date = bfile.expiration_date;

      // check if expiration_date null
      if (expiration_date === "" || expiration_date === null) {
        // use `created_on` date
        expiration_date = moment(bfile.created_on)
          .add(user_default_date, "days")
          .format("MM/DD/YYYY");
      }

      const formattedDate = moment(new Date(expiration_date));
      const cloneFormattedDate = moment(new Date(expiration_date));

      let isPastDate = cloneFormattedDate.add(1, "day") < moment();

      expiration_date = formattedDate.format("MM/DD/YYYY");
      return expiration_date;
      // if (isPastDate) {
      //   return <span style={{ color: "red" }}>{expiration_date}</span>;
      // } else {
      //   return <span>{expiration_date}</span>;
      // }
    }
  },
  bfile_employment_status: (bfile) => {
    let employment_status = "-";
    if (bfile.business_owner_toggle === "1") {
      employment_status = "Business Owner";
    } else {
      if (bfile.employed_toggle === "1") {
        employment_status = "Employed";
      } else {
        if (
          bfile.employed_retired_disabled &&
          bfile.employed_retired_disabled !== "Unemployed"
        ) {
          employment_status = bfile.employed_retired_disabled;
        }
        if (
          bfile.employed_retired_disabled &&
          bfile.employed_retired_disabled === "Unemployed"
        ) {
          employment_status = "Unemployed";
        }
        if (
          bfile.employed_toggle === "0" &&
          (bfile.employed_retired_disabled === null ||
            bfile.employed_retired_disabled === "")
        ) {
          employment_status = "Homemaker";
        }
      }
    }
    return employment_status;
  },
  bfile_get_retirement_dollars: (bfile) => {
    const get_second_value = (str) => {
      if (typeof str !== "undefined" && str !== "" && str !== null) {
        str = str.replace(/\$/g, "");
        str = str.replace(/,/g, "");
        let arr = str.split("-");
        let num;
        if (arr.length > 1) {
          num = arr[1] * 1;
          return num;
        } else {
          arr = str.split("+");
          if (arr.length > 1) {
            num = arr[0] * 1;
            return num;
          }
        }
      }
      return 0;
    };

    let retirement_dollars = 0;
    if (
      bfile.asset_total_value &&
      get_second_value(bfile.asset_total_value)
    ) {
      retirement_dollars += get_second_value(bfile.asset_total_value);
    }
    if (
      bfile.asset_preservation_value &&
      get_second_value(bfile.asset_preservation_value)
    ) {
      retirement_dollars += get_second_value(bfile.asset_preservation_value);
    }
    if (
      bfile.financial_conversion &&
      bfile.financial_conversion.length > 0 &&
      bfile.financial_conversion[0].products_sold !== "" &&
      bfile.financial_conversion[0].products_sold !== null
    ) {
      const products_sold = JSON.parse(
        bfile.financial_conversion[0].products_sold
      );
      for (let j = 0; j < products_sold.length; j++) {
        if (typeof products_sold[j].total_dollars !== "undefined") {
          retirement_dollars =
            retirement_dollars - products_sold[j].total_dollars;
        }
      }
    }
    if (retirement_dollars < 0) retirement_dollars = 0;
    return retirement_dollars;
  },
  bfile_get_ages: (bfile) => {
    let ages = [];
    if (bfile.birthday !== "" && bfile.birthday !== null) {
      ages.push(this.a.getAge(this.a.validDate(bfile.birthday, "/")));
    }
    if (bfile.spouse_birthday !== "" && bfile.spouse_birthday !== null) {
      ages.push(this.a.getAge(this.a.validDate(bfile.spouse_birthday, "/")));
    }
    return ages;
  },
  bfile_get_life_retirement_opp: (bfile) => {
    let life_retirement = "";
    if (
      (bfile.asset_401k_accounts === null ||
        bfile.asset_401k_accounts === "[]" ||
        bfile.asset_401k_accounts === '["None"]') &&
      (bfile.asset_accounts === null ||
        bfile.asset_accounts === "[]" ||
        bfile.asset_accounts === '["None"]')
    ) {
      life_retirement = "Life";
    }
    if (
      (bfile.asset_401k_accounts !== null &&
        bfile.asset_401k_accounts !== "[]" &&
        bfile.asset_401k_accounts !== '["None"]') ||
      (bfile.asset_accounts !== null &&
        bfile.asset_accounts !== "[]" &&
        bfile.asset_accounts !== '["None"]')
    ) {
      life_retirement = "Life/Retirement";
    }
    return life_retirement;
  },
  bfile_renewal_date: (effective_date, term) => {
    if (effective_date && effective_date !== "") {
      const date = effective_date.split("-");
      if (date.length > 2) {
        if (term === "6 Months") {
          return moment(new Date(date[0], parseInt(date[1]) - 1, date[2]))
            .add(6, "months")
            .format("MM/DD/YYYY");
        }
        if (term === "1 Year") {
          return moment(new Date(date[0], parseInt(date[1]) - 1, date[2]))
            .add(1, "years")
            .format("MM/DD/YYYY");
        }
      }
    }
    return "";
  },
  bfile_type: (type, saved_for_later) => {
    if ((type === "New Bfile" || type === "New B File") && !saved_for_later) {
      return "New B File";
      // return F.replaceNewBFileText(type);
    } else if ((type === "New Bfile" || type === "New B File") && saved_for_later) {
      return "Saved For Later";
    } else if (type === "Renewal" && !saved_for_later) {
      return "Renewal";
    } else if (type === "Renewal" && saved_for_later) {
      return "Saved For Later";
    } else if (type === "Referral" && !saved_for_later) {
      return "Referral";
    } else if (type === "Referral" && saved_for_later) {
      return "Saved For Later";
    } else if (type === "Requote" && !saved_for_later) {
      return "Requote";
    } else if (type === "Requote" && saved_for_later) {
      return "Saved For Later";
    } else {
      return "";
    }
  },
  bfile_life_stage: (bfile, agency_owner_details) => {
    let life_stage = "";
    let life_stage_desc = "";
    let life_stage_thumb = null;
    let ages = [];
    if (bfile.birthday !== "" && bfile.birthday !== null) {
      ages.push(this.a.getAge(this.a.validDate(bfile.birthday, "/")));
    }
    if (bfile.spouse_birthday !== "" && bfile.spouse_birthday !== null) {
      ages.push(this.a.getAge(this.a.validDate(bfile.spouse_birthday, "/")));
    }
    if (ages.length > 0) {
      let customer_age = ages[0];
      if (customer_age <= 30) {
        if (bfile.spouse_first_name) {
          life_stage = "Young Household";
          life_stage_desc =
            "Young families facing a world of firsts - first home, first child - and the responsibilities they bring.";
          life_stage_thumb = YoungHousehold;
        } else {
          life_stage = "Emerging Adult";
          life_stage_desc =
            "Twenty somethings who are just grasping the basics of finances and insurance.";
          life_stage_thumb = EmergingAdult;
        }
        // } else if (customer_age <= 50 && (bfile.user.carrier || (agency_owner_details && agency_owner_details.carrier)) !== "Country Financial") {
      } else if (customer_age <= 50) {
        life_stage = "Established Household";
        life_stage_desc =
          "Families on the verge of entering their prime earning years, generally with roots in the community and children in their tweens/teens.";
        life_stage_thumb = EstablishedHousehold;
      } else if (customer_age <= 65) {
        life_stage = "Mature Household";
        life_stage_desc =
          "Families that may have adult children, the lead of retirement on the horizon, and care for aging parents.";
        life_stage_thumb = MatureHousehold;
      } else {
        life_stage = "Retiree";
        life_stage_desc =
          "Retired customers who want to enjoy life and leave their legacy.";
        life_stage_thumb = Retiree;
      }
      if (bfile.employed_retired_disabled === "Retired") {
        life_stage = "Retiree";
        life_stage_desc =
          "Retired customers who want to enjoy life and leave their legacy.";
        life_stage_thumb = Retiree;
      }
    }
    return {
      title: life_stage,
      desc: life_stage_desc,
      thumb: life_stage_thumb
    };
  },
  encrypt: (text) => {
    return btoa(text);
  },
  validateEmail: (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  flattenArray: (arr = [], temp = []) => {
    arr.forEach(e => {
      if (Array.isArray(e.menu)) {
        const nestedArray = e.menu.filter(e1 => Array.isArray(e1.menu));
        const nestedNotArray = e.menu.filter(e1 => !Array.isArray(e1.menu));
        F.flattenArray(nestedArray, temp);
        temp.push(...nestedNotArray);
      } else {
        temp.push(e);
      }
    });
    return temp;
  },
  getObjMenufromKey: (arr, key) => {
    return F.flattenArray(arr).find(e => e.key === key);
  },

  get_user_activity_card_data: (data = {}, type_of_call) => {

    let Card_Data = {
      "review": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.review && data.review.customer_upload_monthly || 0,
          total_count: data.review && data.review.customer_upload_total || 0,
          link: "/newbfiles/review-scheduler-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.review && data.review.schedule_activity_monthly || 0,
          total_count: data.review && data.review.schedule_activity_total || 0,
          link: "/newbfiles/review-scheduler-appointments-scheduled",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.review && data.review.active_calls_monthly || 0,
          total_count: data.review && data.review.active_calls_total || 0,
          link: "/newbfiles/review-scheduler-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.review && data.review.non_responsive_monthly || 0,
          total_count: data.review && data.review.non_responsive_total || 0,
          link: "/newbfiles/review-scheduler-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.review && data.review.not_interested_monthly || 0,
          total_count: data.review && data.review.not_interested_total || 0,
          link: "/newbfiles/review-scheduler-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ],
      "prospect": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.lead && data.lead.customer_upload_monthly || 0,
          total_count: data.lead && data.lead.customer_upload_total || 0,
          link: "/newbfiles/von-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.lead && data.lead.schedule_activity_monthly || 0,
          total_count: data.lead && data.lead.schedule_activity_total || 0,
          link: "/newbfiles/vo-sent-to-financial",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.lead && data.lead.active_calls_monthly || 0,
          total_count: data.lead && data.lead.active_calls_total || 0,
          link: "/newbfiles/vo-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.lead && data.lead.non_responsive_monthly || 0,
          total_count: data.lead && data.lead.non_responsive_total || 0,
          link: "/newbfiles/vo-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.lead && data.lead.not_interested_monthly || 0,
          total_count: data.lead && data.lead.not_interested_total || 0,
          link: "/newbfiles/vo-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ],
      "followup": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.opportunity && data.opportunity.customer_upload_monthly || 0,
          total_count: data.opportunity && data.opportunity.customer_upload_total || 0,
          link: "/newbfiles/von-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.opportunity && data.opportunity.schedule_activity_monthly || 0,
          total_count: data.opportunity && data.opportunity.schedule_activity_total || 0,
          link: "/newbfiles/vo-sent-to-financial",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.opportunity && data.opportunity.active_calls_monthly || 0,
          total_count: data.opportunity && data.opportunity.active_calls_total || 0,
          link: "/newbfiles/vo-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.opportunity && data.opportunity.non_responsive_monthly || 0,
          total_count: data.opportunity && data.opportunity.non_responsive_total || 0,
          link: "/newbfiles/vo-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.opportunity && data.opportunity.not_interested_monthly || 0,
          total_count: data.opportunity && data.opportunity.not_interested_total || 0,
          link: "/newbfiles/vo-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ]
    }

    return Card_Data[type_of_call_format(type_of_call)]
  },





  get_user_activity_card_data_agency_manager: (data = {}, type_of_call) => {

    let Card_Data = {
      "review": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.review && data.review.customer_upload_monthly || 0,
          total_count: data.review && data.review.customer_upload_total || 0,
          link: "/newbfiles/review-scheduler-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.review && data.review.schedule_activity_monthly || 0,
          total_count: data.review && data.review.schedule_activity_total || 0,
          link: "/newbfiles/review-scheduler-appointments-scheduled",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.review && data.review.active_calls_monthly || 0,
          total_count: data.review && data.review.active_calls_total || 0,
          link: "/newbfiles/review-scheduler-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.review && data.review.non_responsive_monthly || 0,
          total_count: data.review && data.review.non_responsive_total || 0,
          link: "/newbfiles/review-scheduler-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.review && data.review.not_interested_monthly || 0,
          total_count: data.review && data.review.not_interested_total || 0,
          link: "/newbfiles/review-scheduler-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ],
      "prospect": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.lead && data.lead.customer_upload_monthly || 0,
          total_count: data.lead && data.lead.customer_upload_total || 0,
          link: "/newbfiles/von-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.lead && data.lead.schedule_activity_monthly || 0,
          total_count: data.lead && data.lead.schedule_activity_total || 0,
          link: "/newbfiles/vo-sent-to-financial",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.lead && data.lead.active_calls_monthly || 0,
          total_count: data.lead && data.lead.active_calls_total || 0,
          link: "/newbfiles/vo-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.lead && data.lead.non_responsive_monthly || 0,
          total_count: data.lead && data.lead.non_responsive_total || 0,
          link: "/newbfiles/vo-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.lead && data.lead.not_interested_monthly || 0,
          total_count: data.lead && data.lead.not_interested_total || 0,
          link: "/newbfiles/vo-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ],
      "followup": [
        {
          name: "Customers Uploaded",
          icon: 'upload',
          monthly_count: data.opportunity && data.opportunity.customer_upload_monthly || 0,
          total_count: data.opportunity && data.opportunity.customer_upload_total || 0,
          link: "/newbfiles/von-calls-made",
          state: {
            title: "Customer Uploaded History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.UPLOAD,
          }
        },
        {
          name: 'Scheduled Activities',
          icon: 'calendar',
          monthly_count: data.opportunity && data.opportunity.schedule_activity_monthly || 0,
          total_count: data.opportunity && data.opportunity.schedule_activity_total || 0,
          link: "/newbfiles/vo-sent-to-financial",
          state: {
            title: "Scheduled Activities History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY,
          }
        },
        {
          name: 'Active Calls',
          icon: 'call',
          monthly_count: data.opportunity && data.opportunity.active_calls_monthly || 0,
          total_count: data.opportunity && data.opportunity.active_calls_total || 0,
          link: "/newbfiles/vo-not-reached",
          state: {
            title: "Active Calls History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.ACTIVE_CALL,
          }
        },
        {
          name: 'Non Responsive',
          icon: 'phone',
          monthly_count: data.opportunity && data.opportunity.non_responsive_monthly || 0,
          total_count: data.opportunity && data.opportunity.non_responsive_total || 0,
          link: "/newbfiles/vo-non-responsive",
          state: {
            title: "Non Responsive History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NON_RESPONSIVE,
          }
        },
        {
          name: 'Not Interested',
          icon: 'sad',
          monthly_count: data.opportunity && data.opportunity.not_interested_monthly || 0,
          total_count: data.opportunity && data.opportunity.not_interested_total || 0,
          link: "/newbfiles/vo-not-interested",
          state: {
            title: "Not Interested History",
            call_type: type_of_call,
            selected_card_type: CARD_HISTORY_TYPE.NOT_INTERESTED,
          }
        },
      ]
    }

    return Card_Data[type_of_call_format(type_of_call)]
  },


  // created for AM 9 card in DASH
  get_activity_card_data_agency_manager: (data = {}, pncRoute = "", type_of_card) => {

    let card = {
      customer_result: [
        // {
        //   name: 'Total Customers Uploaded',
        //   icon: 'people',
        //   count: data.customer_uploaded,
        //   link: "/newbfiles/total_customer_uploaded?dates",
        //   index: 0,
        // },
        {
          md: 8,
          orderIndex: 0,
          name: INTELLIGENCE_LINK_COMPLETED,
          icon: 'file-symlink',
          count: data.combined_rac_files_count,
          link: `/newbfiles/intelligence-link-completed?dates&${new URLSearchParams({
            title: INTELLIGENCE_LINK_COMPLETED,
            selected_card_type: CARD_HISTORY_TYPE.INTELLIGENCE_LINK_COMPLETED
          }).toString()}`,
          index: 0,
        },
        // {
        //   name: 'Follow Up',
        //   icon: 'load',
        //   count: data.follow_up,
        //   link: "/newbfiles/sent-to-vonboarder?dates",
        //   index: 0,
        // },
        // {
        //   name: 'Saved for Later',
        //   icon: 'filter',
        //   count: data.saved_for_later,
        //   link: "/newbfiles/saved_for_later?dates",
        //   index: 1,
        // },
        {
          md: 7,
          orderIndex: 2,
          name: TOTAL_P_AND_C_ITEMS,
          icon: 'shield',
          count: data.total_pnc,
          link: "/newbfiles/cross-sell-policies-uncovered?dates",
          index: 1,
        },
        {
          md: 7,
          orderIndex: 4,
          name: UMBRELLA_RECOMMENDED,
          icon: 'umberella',
          count: data.umbrella_recommended,
          link: "/newbfiles/umbrella-uncovered?dates",
          index: 0,
        },
        {
          md: 7,
          orderIndex: 3,
          name: LIFE_OPPORTUNITIES,
          icon: 'life',
          count: data.life_opportunities,
          link: "/newbfiles/life-opportunities?dates",
          index: 1,
        },
        {
          md: 8,
          orderIndex: 5,
          name: RETIREMENT_ASSETS_UNCOVERED,
          count: F.dollar_format(data.retirement_uncovered),
          link: "/newbfiles/retirement-uncovered?dates",
          index: 3,
        },
        {
          md: 8,
          orderIndex: 6,
          name: TOTAL_ASSETS_UNCOVERED,
          count: F.dollar_format(data.total_assets_uncovered),
          link: "/newbfiles/total-assets-uncovered?dates",
          index: 3,
        }
      ],
      bfile_status: [

      ]
    }

    return card[type_of_card]

  },



  get_activity_card_data: (data = {}, pncRoute = "", type_of_card) => {

    let card = {
      customer_result: [
        // {
        //   name: 'Total Customers Uploaded',
        //   icon: 'people',
        //   count: data.customer_uploaded,
        //   link: "/newbfiles/von-calls-uploaded?dates",
        //   index: 0,
        // },
        {
          md: 8,
          orderIndex: 0,
          name: INTELLIGENCE_LINK_COMPLETED,
          icon: 'file-symlink',
          count: data.combined_rac_files_count,
          link: `/newbfiles/intelligence-link-completed?dates&${new URLSearchParams({
            title: INTELLIGENCE_LINK_COMPLETED,
            selected_card_type: CARD_HISTORY_TYPE.INTELLIGENCE_LINK_COMPLETED
          }).toString()}`,
          index: 0,
        },
        // {
        //   name: 'Follow Up',
        //   icon: 'load',
        //   count: data.follow_up,
        //   link: "/newbfiles/sent-to-vonboarder?dates",
        //   index: 0,
        // },
        // {
        //   name: 'Saved for Later',
        //   icon: 'filter',
        //   count: data.saved_for_later,
        //   link: "/newbfiles/saved_for_later?dates",
        //   index: 1,
        // },
        {
          md: 7,
          orderIndex: 2,
          name: TOTAL_P_AND_C_ITEMS,
          icon: 'shield',
          count: data.total_pnc,
          link: "/newbfiles/cross-sell-policies-uncovered?dates",
          index: 1,
        },
        {
          md: 7,
          orderIndex: 4,
          name: UMBRELLA_RECOMMENDED,
          icon: 'umberella',
          count: data.umbrella_recommended,
          link: "/newbfiles/umbrella-uncovered?dates",
          index: 0,
        },
        {
          md: 7,
          orderIndex: 3,
          name: LIFE_OPPORTUNITIES,
          icon: 'life',
          count: data.life_opportunities,
          link: "/newbfiles/life-opportunities?dates",
          index: 1,
        },
        {
          md: 8,
          orderIndex: 5,
          name: RETIREMENT_ASSETS_UNCOVERED,
          count: F.dollar_format(data.retirement_uncovered),
          link: "/newbfiles/retirement-uncovered?dates",
          index: 3,
        },
        {
          md: 8,
          orderIndex: 6,
          name: TOTAL_ASSETS_UNCOVERED,
          count: F.dollar_format(data.total_assets_uncovered),
          link: "/newbfiles/total-assets-uncovered?dates",
          index: 3,
        }
      ],
      bfile_status: [

      ]
    }

    return card[type_of_card]

  },

  get_combined_rac_count: (response = {}) => {
    const payload = response && response.data !== undefined ? response.data : response;
    const nestedPayload = payload && payload.data && !Array.isArray(payload.data)
      ? payload.data
      : {};
    const candidates = [
      // payload.combined_completed_external_rac_count,
      // payload.combined_rac_count,
      payload.combined_count,
      payload.completed_history_count,
      payload.external_rac_files_count
      // payload.total_count,
      // payload.count,
      // typeof payload.data === "number" ? payload.data : undefined,
      // nestedPayload.combined_completed_external_rac_count,
      // nestedPayload.combined_rac_count,
      // nestedPayload.combined_count,
      // nestedPayload.total_count,
      // nestedPayload.count,
    ];
    const count = candidates.find((value) => value !== undefined && value !== null);

    return Number(count) || 0;
  },

  get_ea_stats: (stats = {}, filter_lsp = "", user_t = "") => {

    if (filter_lsp === "" && user_t === "")
      return {
        customer_uploaded: stats.customer_upload || 0,
        completed: stats.completed || 0,
        saved_for_later: stats.saved_for_later || 0,
        follow_up: stats.sent_to_vonboarder || 0,
        total_pnc: stats.cross_sell_policies_uncovered || 0,
        life_opportunities: stats.sent_to_vonboarder || 0,
        umbrella_recommended: stats.total_umbrella_count || 0,
        retirement_uncovered: stats.retirement_uncovered || 0,
        total_assets_uncovered: stats.total_assets_uncovered || 0,
        external_rac_files_count: stats.external_rac_files_count || 0,
        combined_rac_files_count: stats.combined_rac_files_count || 0
      }
    else
      return {
        customer_uploaded: stats.customer_upload || 0,
        completed: stats.completed || 0,
        saved_for_later: stats.user_saved_for_later || 0,
        follow_up: stats.user_sent_to_vonboarder || 0,
        total_pnc: stats.user_cross_sell_policies_uncovered || 0,
        life_opportunities: stats.user_sent_to_vonboarder || 0,
        umbrella_recommended: stats.user_total_umbrella_count || 0,
        retirement_uncovered: stats.user_retirement_uncovered || 0,
        total_assets_uncovered: stats.total_assets_uncovered || 0,
        external_rac_files_count: stats.external_rac_files_count || 0,
        combined_rac_files_count: stats.combined_rac_files_count || 0
      }
  },

  get_ea_dashboard_bfile_data: (dashboard, filter_lsp, user_t) => {

    let need_attention = 0,
      total_bfile_sent = 0,
      sent_to_vonboarder = 0,
      saved_for_later = 0,
      total_umbrella_count = 0,
      cross_sell_policies_uncovered = 0,
      retirement_uncovered = 0,
      total_assets_uncovered = 0,
      total_customer_uploaded = 0,
      life_opportunities = 0

    if (filter_lsp !== "" && dashboard.agency_stats) {
      for (let i = 0, len = dashboard.lsp.length; i < len; i++) {
        if (dashboard.lsp[i].user.id === filter_lsp) {
          const user_stats = dashboard.lsp[i].stats;
          need_attention = user_stats.user_need_attention || 0;
          sent_to_vonboarder = user_stats.user_sent_to_vonboarder || 0;
          total_bfile_sent = user_stats.user_total_bfile_sent || 0;
          saved_for_later = user_stats.user_saved_for_later || 0;
          total_umbrella_count = user_stats.user_total_umbrella_count || 0;
          cross_sell_policies_uncovered =
            user_stats.user_cross_sell_policies_uncovered || 0;
          retirement_uncovered = user_stats.user_retirement_uncovered || 0;
          total_assets_uncovered =
            user_stats.total_assets_uncovered || 0;
          life_opportunities = user_stats.user_life_opportunities || 0
          total_customer_uploaded = (dashboard.agency_stats && dashboard.agency_stats.review_customer_upload || 0) + (dashboard.vo_stats.FollowUp && dashboard.vo_stats.FollowUp.count || 0) + (dashboard.vo_stats.Prospect && dashboard.vo_stats.Prospect.count || 0)
          break;
        }
      }
    } else if (dashboard.agency_stats && !user_t) {
      need_attention = dashboard.agency_stats.need_attention || 0;
      sent_to_vonboarder = dashboard.agency_stats.sent_to_vonboarder || 0;
      total_bfile_sent = dashboard.agency_stats.total_bfile_sent || 0;
      saved_for_later = dashboard.agency_stats.saved_for_later || 0;
      total_umbrella_count = dashboard.agency_stats.total_umbrella_count || 0;
      cross_sell_policies_uncovered =
        dashboard.agency_stats.cross_sell_policies_uncovered || 0;
      total_bfile_sent = dashboard.agency_stats.total_bfile_sent || 0;
      retirement_uncovered = dashboard.agency_stats.retirement_uncovered || 0;
      total_assets_uncovered =
        dashboard.agency_stats.total_assets_uncovered || 0;
      life_opportunities = dashboard.agency_stats.life_opportunities || 0
      total_customer_uploaded = (dashboard.agency_stats && dashboard.agency_stats.review_customer_upload || 0) + (dashboard.vo_stats.FollowUp && dashboard.vo_stats.FollowUp.count || 0) + (dashboard.vo_stats.Prospect && dashboard.vo_stats.Prospect.count || 0)

    }

    return {
      need_attention,
      sent_to_vonboarder,
      total_bfile_sent,
      saved_for_later,
      total_umbrella_count,
      cross_sell_policies_uncovered,
      retirement_uncovered,
      total_assets_uncovered,
      total_customer_uploaded,
      life_opportunities
    }

  },

  getActualNotesAndPostFixData: (notes) => {
    let actualNotes = "";
    let postfixNotes = "";

    if (notes) {
      actualNotes = notes;

      const index = notes.indexOf("Thank you");
      if (index >= 0) {
        actualNotes = notes.slice(0, index);
        postfixNotes = notes.slice(index, notes.length);

        if (actualNotes.includes("Send B File")) {
          actualNotes = "Send B File for.";
        }
      }
    }
    return { actualNotes, postfixNotes };
  },

  correctTypeOfCall: (type = "") => {

    if (type && ['followup'].includes(type.split(" ").join("").split("-").join("").toLowerCase().trim())) {
      return 'FollowUp'
    }
    if (type && ['prospect'].includes(type.split(" ").join("").split("-").join("").toLowerCase().trim())) {
      return 'Prospect'
    }
    if (type && ['review'].includes(type.split(" ").join("").split("-").join("").toLowerCase().trim())) {
      return 'Review'
    }
    return type;

  },

  stripHtml: (html = "") => {
    return html.replace(/<[^>]*>/g, "");
  },


  getActualNotesSubType: (notes = "", type_of_call = "") => {
    let str = "Request Call has been created for";

    if (notes && notes.includes("Prospect") || notes.includes("FollowUp")) {
      return notes.replace("Prospect", "Lead").replace("FollowUp", "Opportunity")
    }
    if (notes && notes.includes(str)) {
      return str + " " + get_label_from_value(notes.slice(str.length), 'label', type_of_call)
    }
    Object.keys(SUB_TYPE_OF_CALL).forEach(key => {
      notes.split(" ").forEach(note => {
        if (type_of_call_format(note).includes(key.toLowerCase())) {
          type_of_call = key;
        }

      })
    })

    if (type_of_call && type_of_call !== "" && type_of_call !== null) {
      SUB_TYPE_OF_CALL[F.correctTypeOfCall(type_of_call)] && Array.isArray(SUB_TYPE_OF_CALL[F.correctTypeOfCall(type_of_call)]) && SUB_TYPE_OF_CALL[F.correctTypeOfCall(type_of_call)].forEach(e => {
        if (notes.includes(e.value) && !notes.includes(e.label)) {
          notes = notes.replace(e.value, e.label);
        }
        else if (notes.includes(e.label) && !notes.includes(e.value)) {
          notes = notes.replace(e.label, e.label);
        }
      })
    }

    return notes;


  },

  lifeInsurance: (
    wizard,
    minimum_liability_limits_ext,
    user_invited_user,
    invited_user
  ) => {
    const get_second_value = (str) => {
      if (typeof str !== "undefined" && str !== "" && str !== null) {
        str = str.replace(/\$/g, "");
        str = str.replace(/,/g, "");
        let arr = str.split("-");
        let num;
        if (arr.length > 1) {
          num = arr[1] * 1;
          return num;
        } else {
          arr = str.split("+");
          if (arr.length > 1) {
            num = arr[0] * 1;
            return num;
          }
        }
      }
      return 0;
    };
    // F.log(
    //   "this.state",
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "7x"
    // );
    let multiplier;
    if (
      invited_user &&
      user_invited_user &&
      user_invited_user["Suggested Minimum Life Insurance"] == "5x"

      // minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "5x"
    ) {
      multiplier = 5;
    }
    if (
      (invited_user === undefined || invited_user === null) &&
      minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "5x"
    ) {
      multiplier = 5;
    }

    if (
      invited_user &&
      user_invited_user &&
      user_invited_user["Suggested Minimum Life Insurance"] == "7x"

      // minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "5x"
    ) {
      multiplier = 7;
    }
    if (
      (invited_user === undefined || invited_user === null) &&
      minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "7x"
    ) {
      multiplier = 7;
    }

    if (
      invited_user &&
      user_invited_user &&
      user_invited_user["Suggested Minimum Life Insurance"] == "10x"

      // minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "5x"
    ) {
      multiplier = 10;
    }
    if (
      (invited_user === undefined || invited_user === null) &&
      minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "10x"
    ) {
      multiplier = 10;
    }

    if (
      invited_user &&
      user_invited_user &&
      user_invited_user["Suggested Minimum Life Insurance"] == "3x"

      // minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "5x"
    ) {
      multiplier = 3;
    }
    if (
      (invited_user === undefined || invited_user === null) &&
      minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "3x"
    ) {
      multiplier = 3;
    }

    // if (
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "7x"
    // ) {
    //   multiplier = 7;
    // }

    // if (
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "10x"
    // ) {
    //   multiplier = 10;
    // }

    // if (
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"] == "3x"
    // ) {
    //   multiplier = 3;
    // }

    // if (
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"] ==
    //   undefined
    // ) {
    //   multiplier = 3;
    // }

    // F.log(
    //   "this.state",
    //   multiplier,
    //   minimum_liability_limits_ext["Suggested Minimum Life Insurance"]
    // );

    let mortgage_balance =
      parseInt(get_second_value(wizard.home_mortgage)) +
      parseInt(get_second_value(wizard.secondary_home_mortgage));
    let children =
      typeof wizard.children === "number"
        ? parseInt(wizard.children) * 100000
        : 0;
    // F.log("bff", wizard);
    let annual_income =
      parseInt(get_second_value(wizard.employed_anual_income)) * multiplier;
    // F.log(annual_income, "annual_income");
    // F.log("home mortgage =>", wizard.home_mortgage);
    // F.log("home mortgage =>", wizard.children);
    // F.log("home mortgage =>", wizard.employed_annual_income);

    let totalInsurance =
      (mortgage_balance ? mortgage_balance : 0) +
      (children ? children : 0) +
      (annual_income ? annual_income : 0);
    // F.log("Total Insurance = > ", totalInsurance);

    totalInsurance = isNaN(totalInsurance) ? 0 : totalInsurance;
    // F.log("totalInsurance", totalInsurance);

    return totalInsurance;
    // return (
    //   <Card bordered={false}>
    //     <Card.Grid style={gridStyle} hoverable={false}>
    //       <Card.Meta
    //         style={gridStyle4}
    //         avatar={<Avatar src={LifeInsurance} size="large" />}
    //         title={F.dollar_format(totalInsurance)}
    //       />
    //       {/* {F.dollar_format(totalInsurance)} */}
    //     </Card.Grid>
    //   </Card>
    // );
  },
  isProductionHost: () => {
    return window.location.host === "bfilesystem.com";
  },
  slicePoliciesIntoChunks: (arr, chunkSize = 6, checkType = true) => {
    // arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    // chunkSize = 6

    // const newArr = arr.filter((p) => p.type !== "Umbrella");

    let newArr = arr;
    if (checkType) {
      newArr = arr.filter((p) => p.type !== "Umbrella");
    }

    const res = [];
    for (let i = 0; i < newArr.length; i += chunkSize) {
      const chunk = newArr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res; // [[1, 2, 3, 4], [5, 6, 7, 8], [9, 10]]
  },
  mylog: (function () {
    return {
      log: function () {
        var args = Array.prototype.slice.call(arguments);
        //console.log.apply(console, args);
      },
      warn: function () {
        var args = Array.prototype.slice.call(arguments);
        //console.warn.apply(console, args);
      },
      error: function () {
        var args = Array.prototype.slice.call(arguments);
        //console.error.apply(console, args);
      }
    };
  })(),
  /**
   * Validate fields: Setup Appointment RS & VON
   * @param {*} timezone
   * @param {*} customer_info
   * @param {*} has_calendly
   * @param {*} type
   * @param {*} note
   * @returns
   */
  checkAllFieldsValidated: (
    timezone,
    customer_info,
    scheduled_via,
    type,
    note,
    hasScheduledAppointmentWithCalendly,
    type_of_call,
    sub_type_of_call,
    microsoft_data
  ) => {
    // reset notification
    message.destroy();
    if (scheduled_via.length === 0) {
      message.error(F.translate(`Select a link to schedule appointment.`));
      return false;
    }

    if (type.trim().length === 0) {
      message.error(F.translate(`Select appointment location.`));
      return false;
    }

    if (type_of_call.trim().length === 0) {
      message.error(F.translate(`Select Type of Call.`));
      return false;
    }

    if (sub_type_of_call.trim().length === 0) {
      message.error(F.translate(`Select Sub Type of Call.`));
      return false;
    }

    // if (scheduled_via === 'Calendly') {
    //   if (
    //     customer_info.first_name != null &&
    //     customer_info.first_name.length === 0
    //   ) {
    //     message.error("First Name is required.");
    //     return false;
    //   } else if (
    //     customer_info.last_name != null &&
    //     customer_info.last_name.length === 0
    //   ) {
    //     message.error("Last Name is required.");
    //     return false;
    //   } else if (
    //     customer_info.email != null &&
    //     customer_info.email.length === 0
    //   ) {
    //     message.error("Email is required.");
    //     return false;
    //   } else if (
    //     customer_info.phone === null ||
    //     customer_info.phone.trim().length === 0
    //   ) {
    //     message.error("Phone number is required.");
    //     return false;
    //   } else if (!F.validatePhoneRegix(customer_info.phone.trim())) {
    //     message.error("Phone is Invalid");
    //     return false;
    //   } else if (!hasScheduledAppointmentWithCalendly) {
    //     // new add
    //     message.error("Please select an appointment with Calendly");
    //     return false;
    //   }
    // } 
    // else {
    if (timezone == undefined || timezone.length === 0) {
      message.error("Select Timezone.");
      return false;
    }
    // }

    if (note.trim().length === 0) {
      message.error(F.translate(`Note is required.`));
      return false;
    }

    // if (microsoft_data.filtered_questions) {
    //   const answerQuestion = microsoft_data.frontend_answers;

    //   let requiredQuestions = microsoft_data.filtered_questions.filter(q => q.isRequired);

    //   let missingAnswers = requiredQuestions.filter(q =>
    //     !answerQuestion.some(a => a.id === q.id && a.answer.trim())
    //   );

    //   if (missingAnswers.length > 0) {
    //     let missingQuestions = missingAnswers.map(q => q.displayName.replace(/\?/g, ''));

    //     if (missingQuestions.length > 1) {
    //       missingQuestions = missingQuestions.join(', ');
    //     }
    //     message.error(`Please fill ${missingQuestions} field${missingAnswers.length > 1 ? 's' : ''}.`);
    //     return false;
    //   }
    // }

    return true;
  },
  replaceNewBFileText: (status) => {
    return status != null && status == "New Bfile" ? "New B File" : status;
  },
  convertTypeOfCall: (bfiles) => {
    return bfiles.map(item => {
      return {
        ...item,
        type_of_call: TYPE_OF_CALL[`${item.type_of_call}`],
      }
    });
  },
  getTypeOfCall: (bfile, defaultReturn = "") => {
    return bfile.type_of_call && bfile.type_of_call != "Life" ? TYPE_OF_CALL[`${bfile.type_of_call}`] : defaultReturn;
  }
  ,
  getSubTypeOfCall: (bfile, defaultReturn = "") => {
    return bfile.sub_type_of_call != null && bfile.sub_type_of_call
      ? bfile.sub_type_of_call
      : defaultReturn;
  },
  getFarmBureauNumber: (bfile, defaultReturn = "") => {
    return bfile.farm_bureau_number != null && bfile.farm_bureau_number
      ? bfile.farm_bureau_number
      : defaultReturn;
  },
  /**
   * Get Virtual-OnBorder Scheduled Appointment Date From BFile
   * @param {*} bfile
   * @returns
   */
  getVonBorderAppointmentDateFromBFile: (bfile) => {
    return bfile.von_appointment_date
      ? bfile.von_appointment_date
      : bfile.rs_appointment_date;
  },
  showAndHandleServerError: (error) => {
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      message.error(error.response.data.message);
    }
  },
  isVonBorderBFileCompleted: (bfile) => {
    return (
      bfile.bfile_folow_up_completed != null &&
      bfile.bfile_folow_up_completed == "1"
    );
  },
  /**
   * This method validate first then show `Complete` action on `Agency Owner`
   * and `Agency Staff` B Files which comes from the Von-Boarder after
   * claiming and scheduling the appointment
   * @param {*} bfile
   * @returns
   */
  isBFileClaimedAndAppointmentScheduledFromVonBoarder: (bfile) => {
    return (
      bfile.financial_id != null &&
      bfile.vob_completed == "1" &&
      bfile.vo_claim_date != null
    );
  },
  /**
   *  Remove Duplicate Objects From Array
   * @param {*} arr
   * @returns
   */
  removeDuplicateFromArray: (arr) => {
    const uniqueIds = [];

    const unique = arr.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.id);

      if (!isDuplicate) {
        uniqueIds.push(element.id);

        return true;
      }

      return false;
    });
    return unique;

    /**
     const arr = [
          {id: 1, name: 'Tom'},
          {id: 1, name: 'Tom'},
          {id: 2, name: 'Nick'},
          {id: 2, name: 'Nick'},
      ];
      👇️ 
      Response: [{id: 1, name: 'Tom'}, {id: 2, name: 'Nick'}]
     */
  },
  testCal: (bFiles, callpage) => {
    let val = 0;
    let a = 0;

    for (let i = 0; i < bFiles.length; i++) {
      // Total Retirement $ Uncovered
      if (callpage === "retirement-uncovered") {
        a = F.bfile_get_retirement_dollars(bFiles[i]);
      }

      // P&C Cross Sell Opportunities
      if (callpage === "cross-sell-policies-uncovered") {
        a = bFiles[i].cross_sell_policies_uncovered;
      }

      // Total Assets Uncovered
      if (callpage === "total-assets-uncovered") {
        a = Number(bFiles[i].liability_calculator_value);
      }

      val += a;
    }

    if (val > 0) {
      F.log("------ FINAL RESULT ----- " + val);
    }
  },
  getSelectedBFileIDsWithParticularPage: (selectedPageAndBFileIDs) => {
    let arrayData = Object.values(selectedPageAndBFileIDs); // e.g: [[1000, 3000], [2000, 5000]]

    const bfilesArray = [];

    for (let i = 0; i < arrayData.length; i++) {
      bfilesArray.push(...arrayData[i]);
    }

    return bfilesArray; // e.g: [1000, 3000, 2000, 5000]
  },
  getWizardHomeValue: (wizard) => {
    // return wizard.home_toggle == "0" ? "" : "$100,000";
    if (wizard.home_toggle == "1") {
      return "$100,000";
    }
    return "";
  },
  testSave: (wizard) => {
    // F.log("Policies ==>> Length ==>> " + wizard.policies.length);

    const totalPnCItems =
      wizard.cross_sell_policies_uncovered +
      wizard.primary_vehicles_num +
      (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

    F.log(
      "ORANGE cross_sell_policies_uncovered ==>> " +
      wizard.cross_sell_policies_uncovered
    );

    F.log("ORANGE primary_vehicles_num ==>> " + wizard.primary_vehicles_num);

    F.log(
      "ORANGE toggle ==>> " +
        (wizard.home_toggle === "1" || wizard.home_toggle === "2")
        ? 1
        : 0
    );

    F.log("ORANGE ==>> " + totalPnCItems);
  },
  removeEmojis: (string) => {
    var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

    return string.replace(regex, "");
  },
  removeSpecialCharactersFromString: (string) => {
    string = string.replace(/[&\/\\#,+()$~%'":*?<>{}|!^;=`]/g, "");
    return F.removeEmojis(string);
  },

  getInt: (val) => {
    if (isNaN(parseInt(val))) return 0
    else return parseInt(val)
  },


  getPreviousCallAttemptCount: (user_type, bfile) => {
    const selectedRoleFilter = useBoundStore.getState().RSFSCardFilters.selectedRoleFilter;
    switch (user_type) {
      case REVIEWSCHEDULER:
        return F.getInt(bfile.attempts) + F.getInt(bfile.rs_attempts) || 0;
      case VONBOARDER:
        return F.getInt(bfile.attempts) +
          parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) || 0;
      case VONSCHEDULER:
        if (selectedRoleFilter === REVIEWSCHEDULER)
          return F.getInt(bfile.attempts) + F.getInt(bfile.rs_attempts) || 0;
        else
          return F.getInt(bfile.attempts) +
            parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) || 0;
      default:
        return parseInt(F.getCallAttemptsFromBFileQuestionArray(bfile)) +
          F.getInt(bfile.attempts) +
          F.getInt(bfile.rs_attempts) || 0;
    }
  },


  getServerDateByType: (period) => {
    let data = {};

    // Handle for "All B Files"
    if (period === "all_bfiles") {
      data.from = moment(new Date("2010-01-01")).format("YYYY-MM-DD");
      data.to = moment(new Date("2050-01-01")).format("YYYY-MM-DD");
    }
    // Handle for "This Month"
    if (period === "mtd") {
      data.from = moment(
        new Date(today.getFullYear(), today.getMonth(), 1)
      ).format("YYYY-MM-DD");
      data.to = moment(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");
    }
    // Handle for "This Year"
    if (period === "ytd") {
      const year = new Date().getFullYear();
      data.from = year + "-01-01";
      data.to = year + "-12-31";
    }
    return data;
  },

  getCallAttemptsFromBFileQuestionArray: (bfile) => {
    let callAttempts = 0;
    // check `questions` in bfile has data ( Not Reached Data )
    if (bfile.questions != null && bfile.questions.length > 0) {
      // traverse question data and calculate `call_attempts` ( Not Reached Attempt )
      for (let i = 0; i < bfile.questions.length; i++) {
        const serverCallAttempt = bfile.questions[i].call_attempts;
        if (
          typeof serverCallAttempt != "undefined" &&
          !isNaN(serverCallAttempt)
        ) {
          callAttempts = callAttempts + serverCallAttempt;
        }
      }
    }
    return callAttempts;
  },

  nullifyCallAttemptsQuestionArray: (bfile) => {
    if (bfile.questions != null && bfile.questions.length > 0) {
      // traverse question data and nullify `call_attempts`
      bfile["questions"] = bfile.questions.map((item) => {
        return {
          ...item,
          call_attempts: 0
        }
      })
    }
    return bfile;
  },

  validateUserProfileFields: (user, agency) => {
    // reset notification
    message.destroy();
    if (user.first_name.trim().length === 0) {
      message.error("First Name is required.");
      return false;
    }
    if (user.last_name.trim().length === 0) {
      message.error("Last Name is required.");
      return false;
    }

    if (user.user_type == EA && (user.email.trim().length == 0)) {
      message.error(EMAIL_IS_REQUIRED);
      return false;
    }

    if (user.user_type == EA && (user.email && !F.validateEmail(user.email))) {
      message.error(EMAIL_ADDRESS_IS_INVALID);
      return false;
    }

    if (user.user_type == EA && (!agency || !agency.name || agency.name.trim().length === 0)) {
      message.error(AGENCY_NAME_IS_REQUIRED);
      return false;
    }


    if ((user.user_type !== "AGENCY_MANAGER") && (user.language === null || user.language === undefined || user.language.trim().length === 0)) {
      message.error("Please select a language");
      return false;
    }

    if (user.user_type !== "LSP") {
      if (user.phone === null || user.phone.trim().length === 0) {
        message.error("Phone Number is required.");
        return false;
      }

      if (!F.validatePhoneRegix(user.phone.trim())) {
        message.error("Phone is Invalid");
        return false;
      }

      // if (
      //   user.mobile_number === null ||
      //   user.mobile_number.trim().length === 0
      // ) {
      //   message.error("Mobile Number is required.");
      //   return false;
      // }

      if (
        user.mobile_number != null &&
        user.mobile_number.trim().length > 0 &&
        !F.validatePhoneRegix(user.mobile_number.trim())
      ) {
        message.error("Mobile Number is Invalid");
        return false;
      }

      // if (user.address == null || user.address.trim().length === 0) {
      //   message.error("Address is required.");
      //   return false;
      // }

      // if (user.city == null || user.city.trim().length === 0) {
      //   message.error("City is required.");
      //   return false;
      // }

      // if (user.state === null || user.state.trim().length === 0) {
      //   message.error("State is required.");
      //   return false;
      // }

      // if (user.zipcode === null || user.zipcode.trim().length === 0) {
      //   message.error("ZipCode is required.");
      //   return false;
      // }

      // if (
      //   user.timezone == null ||
      //   user.timezone == undefined ||
      //   user.timezone.length === 0
      // ) {
      //   message.error("Select Timezone.");
      //   return false;
      // }

      // if (user.default_date == null && user.user_type !== "AGENCY_MANAGER") {
      //   message.error("Please Select Follow Up Calls.");
      //   return false;
      // }
    }

    // if ((user.user_type === "EA" || user.user_type === "LSP") && user.manual_microsoft_enable) {
    //   if (user.rs_manual_microsoft === "" || !user.rs_manual_microsoft.includes("https:")) {
    //     message.error("Please input the RS Service Url correctly")
    //     return false
    //   }

    //   if (user.vo_manual_microsoft === "" || !user.vo_manual_microsoft.includes("https:")) {
    //     message.error("Please input the VO Service Url correctly")
    //     return false
    //   }
    // }

    return true;
  },

  isVirtualFollowUpAppointmentScheduledAndBFileNotCompleted: (bfile) => {
    return (
      // Appointment Scheduled
      bfile.vob_completed != null &&
      bfile.vob_completed == 1 &&
      //
      bfile.vob_archived == null &&
      bfile.deleted == 0 &&
      bfile.is_saved_for_later == 0 &&
      bfile.archive == 0 &&
      F.isVonBorderBFileCompleted(bfile) === false
    );
  },

  isAppointmentScheduledAndBFileNotCompleted: (bfile) => {
    return (
      bfile.rs_action != null &&
      bfile.rs_action == 1 &&
      bfile.deleted == 0 &&
      bfile.is_saved_for_later == 0 &&
      bfile.archive == 0 &&
      bfile.rs_archived != 1 // check for `Not-Complete`
    );
  },

  isVobAttempted: (bfile) => {
    return (
      // Not Reached - Case
      bfile.vob_attempted != null &&
      bfile.vob_attempted == 1 &&
      // `Not Reached` & `Not Interested` - Case
      bfile.vob_completed == null &&
      bfile.vob_archived == null &&
      bfile.onboarding_id != null &&
      //
      F.isVonBorderBFileCompleted(bfile) === false
    );
  },

  getFutureDateForAppointment: () => {
    const date = new Date();

    // add a day
    date.setDate(date.getDate() + 1);

    return date;
  },

  getFutureDateForAppointmentFromAntdDatePicker: (current) => {
    // Can not select days before today and today
    return current && current <= new Date();
  },

  getSelectedCalendlyEventType: (
    calendly_selected_event_type_key,
    calendly_event_types
  ) => {
    let index = -1;

    if (
      calendly_selected_event_type_key != null &&
      calendly_event_types != null
    ) {
      index = calendly_event_types.findIndex(
        (item) => item.uri == calendly_selected_event_type_key
      );
    }

    if (index >= 0) {
      return calendly_selected_event_type_key;
    } else {
      return null;
    }
  },

  validateCsvColumns: (
    col,
    default_template_columns = [
      "First Name",
      "Last Name",
      "E-mail",
      "Mailing Street1",
      "Mailing Street2",
      "Mailing City",
      "Mailing State",
      "Mailing Zip",
      "Home Phone",
      "Cell Phone",
      "Schedule by Date",
      "Policy Type",
      "Active Call Date",
      "P&C Item to Quote",
      "Notes"
    ]
  ) => {
    // convert csv columns to lower case for comparing
    const csv_columns = col.map(function (x) {
      return x
        .trim()
        .replace(/\W+/g, "")
        .toLowerCase();
    });

    // will add csv column's title which are required but couldn't find in uploaded csv file
    const missing_columns = [];

    for (let i = 0; i < default_template_columns.length; i++) {
      const template_column = default_template_columns[i];

      const template_column_lowercase = template_column
        .replace(/\W+/g, "")
        .toLowerCase();

      if (!csv_columns.includes(template_column_lowercase)) {
        missing_columns.push(template_column);
      }
    }

    const hasError = missing_columns.length > 0;

    if (hasError) {
      const missing_columns_string = missing_columns
        .map((d) => `"${d}"`)
        .join(", ");

      const form_of_verb = missing_columns.length > 1 ? "are" : "is";
      const header_of_verb = missing_columns.length > 1 ? "headers" : "header";

      // missing columns string formated like 'A,B,C and D'
      const missing_columns_string_formated = missing_columns_string.replace(
        /,(?=[^,]+$)/,
        " and"
      );

      message.destroy();
      message.error(
        missing_columns_string_formated +
        ` ${form_of_verb} missing ${header_of_verb} in CSV file.`,
        3
      );
    }

    return hasError;
  },

  getCsvOrderedColumns: (
    type_of_call,
    sub_type_of_call,
    state_ordered_cols
  ) => {
    // get csv fields from the selected `Call Type` & `Call Sub Type`
    const fieldsList = CSV_FORM_FIELDS[type_of_call][sub_type_of_call];

    const ordered_cols = {};
    let checkError = false;

    for (let i = 0; i < fieldsList.length; i++) {
      const element = fieldsList[i];

      let columnTitle = state_ordered_cols[element.key];

      // validate if user don't select related field on UI dropdown
      if (element.required && columnTitle === null) {
        message.error(`Please select ${element.value} field`);
        checkError = true;
        break;
      }

      columnTitle =
        columnTitle !== null ? columnTitle.replace("\r", "") : columnTitle;

      // test work
      // let newKey = element.key;
      // let newKey = columnTitle !== null ? element.key : null;
      // if (columnTitle != null) {
      //   for (let j = 0; j < fieldsList.length; j++) {
      //     if (fieldsList[j].value == columnTitle) {
      //       newKey = fieldsList[j].key;
      //     }
      //   }
      // }

      ordered_cols[element.key] = columnTitle; // OLD
      // ordered_cols[element.key] = newKey; // NEW
    }

    /**
       * [
      { key: "first_name", value: "First Name" },
      { key: "last_name", value: "Last Name" },
      { key: "phone", value: "Phone" },
      { key: "email", value: "Email" },
      { key: "rs_effective_date", value: "Effective Date" },
      { key: "notes", value: "Notes" },
    ]
    */

    if (checkError) return null;

    return JSON.stringify(ordered_cols);
  },

  log: (...args) => {
    // console.log(args.toString());
  },
  compareStrings: (str1, str2) => {
    if (str1 != null && str2 != null) {
      str1 = str1
        .trim()
        .replace(/\W+/g, "")
        .toLowerCase();

      str2 = str2
        .trim()
        .replace(/\W+/g, "")
        .toLowerCase();

      return str1 === str2;
    }
    return false;
  },
  getQuerySearchFilters: (more_filters) => {
    const queries = [];
    queries.push({
      name: "first_name",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "last_name",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "spouse_first_name",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "spouse_last_name",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "email",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "phone",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });
    queries.push({
      name: "phone2",
      op: "like",
      val: encodeURIComponent("%" + more_filters.search + "%")
    });

    const search_arr = more_filters.search.split(" ");
    for (let x in search_arr) {
      if (x != "" && search_arr[x] !== "") {
        queries.push({
          name: "first_name",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        queries.push({
          name: "last_name",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        queries.push({
          name: "spouse_first_name",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        queries.push({
          name: "spouse_last_name",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        ///
        queries.push({
          name: "email",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        queries.push({
          name: "phone",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
        queries.push({
          name: "phone2",
          op: "like",
          val: encodeURIComponent("%" + search_arr[x] + "%")
        });
      }
    }
    return queries;
  },
  /**
   *
   * @param {*} filters
   * @param {*} dncBFilesOnly `true` will return only DNC B Files
   * @param {*} isObject `true` if filters type is object
   * @returns
   */
  getDncFilter: (filters, dncBFilesOnly = false, isObject = false) => {
    if (isObject) {
      if (dncBFilesOnly) {
        filters.push({ name: "dnc_status", op: "==", val: 1 });
      } else {
        filters.push({
          or: [
            {
              name: "dnc_status",
              op: "is_null"
            },
            {
              name: "dnc_status",
              op: "==",
              val: 0
            }
          ]
        });
      }
    } else {
      if (dncBFilesOnly) {
        filters = `${filters},{"name":"dnc_status","op":"==","val":"1"}`;
      } else {
        filters = `${filters},{"or":[{"name":"dnc_status","op":"is_null"},{"name":"dnc_status","op":"==","val":"0"}]}`;
      }
    }
    return filters;
  },
  checkAllColumnsCorrectlySelected: (ordered_cols) => {
    // reset notification
    message.destroy();
    let allColumnsCorrectlySelected = true;

    for (let index = 0; index < CSV_COLUMNS.length; index++) {
      const defined_column_element = CSV_COLUMNS[index]; // default fields

      const csv_column_title = ordered_cols[defined_column_element.key];

      const isEqual = F.compareStrings(
        csv_column_title,
        defined_column_element.value
      );

      if (csv_column_title != null && !isEqual) {
        const errorMsg = `Select the correct column for "${defined_column_element.value}" field.`;
        message.error(errorMsg);
        allColumnsCorrectlySelected = false;
        break;
      }
    }
    return allColumnsCorrectlySelected;
  },
  checkAllColumnsExistInCsvSheetColumns: (cols) => {
    /**
     * Create Inner Function - Closure
     *
     * Convert CSV columns to lower case for comparing
     */
    function getCsvColumnsInLowerCaseArray() {
      const res = cols.map((col) =>
        col
          .trim()
          .replace(/\W+/g, "")
          .toLowerCase()
      );
      return res;
    }
    const csv_columns = getCsvColumnsInLowerCaseArray();

    const ordered_cols = {};

    for (let i = 0; i < CSV_COLUMNS.length; i++) {
      const defined_column_element = CSV_COLUMNS[i];

      const define_column_value = defined_column_element.value
        .replace(/\W+/g, "")
        .toLowerCase();

      const value = csv_columns.includes(define_column_value)
        ? defined_column_element.value
        : null;

      ordered_cols[defined_column_element.key] = value;
    }
    return ordered_cols;
  },
  checkProfilePDFHeaderHasContent: (bfile, header_type) => {
    // break constants object
    const {
      Life_Stage,
      Household_Total_Assets,
      P_n_C_ITEMS_IN_THE_HOUSEHOLD
    } = PROFILE_PDF_HEADERS;

    // default set `false`
    let has_content = false;

    // first check for `LIFE STAGE` Header on Profile PDF
    if (header_type === Life_Stage) {
      // check one of the condition true
      if (
        bfile.birthday ||
        bfile.children ||
        bfile.home_mortgage ||
        bfile.home_mortgage_protection_toggle
      ) {
        has_content = true;
      }
    }

    // check for `Household Total Assets` Header on Profile PDF
    if (header_type === Household_Total_Assets) {
      if (
        bfile.liability_calculator_value &&
        bfile.liability_calculator_value !== "0"
      ) {
        has_content = true;
      }
    }

    // check for `P & C ITEMS IN THE HOUSEHOLD` Header on Profile PDF
    if (header_type === P_n_C_ITEMS_IN_THE_HOUSEHOLD) {
      if (bfile.policies && bfile.policies.length > 0) {
        has_content = true;
      }
    }
    return has_content;
  },
  getAgencyData: (wizard) => {
    let agency_name = null;
    let agency_address = "Not Available";
    let agency_email = null;
    let agency_phone = null;

    const agencyData = DataHandler.getTempHoldAgencyData();

    if (wizard.agency_info && wizard.agency_info.name) {
      agency_name = wizard.agency_info.name;
    }
    if (agency_name == null && agencyData) {
      agency_name = agencyData.name;
    }

    if (wizard.agency_info && wizard.agency_info.address) {
      agency_address = wizard.agency_info.address;
    }
    if (agency_address === "Not Available" && agencyData) {
      agency_address = agencyData.address;
    }

    if (wizard.agency_info && wizard.agency_info.email) {
      agency_email = wizard.agency_info.email;
    }
    if (agency_email == null && agencyData) {
      agency_email = agencyData.email;
    }

    if (wizard.agency_info && wizard.agency_info.phone) {
      agency_phone = F.phone_format(wizard.agency_info.phone);
    }
    if (agency_phone == null && agencyData) {
      agency_phone = F.phone_format(agencyData.phone);
    }

    return { agency_name, agency_address, agency_email, agency_phone };
  },
  getRangeValues_10M: () => {
    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000",
      "$1,000,001-$1,100,000",
      "$1,100,001-$1,200,000",
      "$1,200,001-$1,300,000",
      "$1,300,001-$1,400,000",
      "$1,400,001-$1,500,000",
      "$1,500,001-$1,600,000",
      "$1,600,001-$1,700,000",
      "$1,700,001-$1,800,000",
      "$1,800,001-$1,900,000",
      "$1,900,001-$2,000,000",
      "$2,000,001-$2,100,000",
      "$2,100,001-$2,200,000",
      "$2,200,001-$2,300,000",
      "$2,300,001-$2,400,000",
      "$2,400,001-$2,500,000",
      "$2,500,001-$2,600,000",
      "$2,600,001-$2,700,000",
      "$2,700,001-$2,800,000",
      "$2,800,001-$2,900,000",
      "$2,900,001-$3,000,000",
      "$3,000,001-$4,000,000",
      "$4,000,001-$5,000,000"
    ];


    let step = 500000;
    let start = 5000001;
    let count = 10;

    for (let i = 0; i < count; i++) {
      let v1 = start + step * i;
      let v2 = v1 + step - 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }

    return rangeValues;
  },

  // getRangeValues_10M: () => {
  //   let rangeValues = [
  //     "",
  //     "$1-$10,000",
  //     "$10,001-$25,000",
  //     "$25,001-$50,000",
  //     "$50,001-$100,000",
  //     "$100,001-$150,000",
  //     "$150,001-$200,000",
  //     "$200,001-$250,000",
  //     "$250,001-$300,000",
  //     "$300,001-$350,000",
  //     "$350,001-$400,000",
  //     "$400,001-$450,000",
  //     "$450,001-$500,000",
  //     "$500,001-$600,000",
  //     "$600,001-$700,000",
  //     "$700,001-$800,000",
  //     "$800,001-$900,000",
  //     "$900,001-$1,000,000"
  //   ];
  //   let v1, v2;
  //   // for (let i = 1; i < 21; i++) {
  //   //   v2 = 1000000 + 100000 * i;
  //   //   v1 = v2 - 100000 + 1;
  //   //   rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
  //   // }
  //   // rangeValues.push("$3,000,001-$4,000,000");
  //   // rangeValues.push("$4,000,001-$5,000,000");


  //   //  calling for primary homes  //   estimated market value of all selected secondary properties
  //   let step = 500000;
  //   for (let i = 1; i <= 18; i++) {
  //     v2 = 1000000 + step * i;
  //     v1 = v2 - step + 1;
  //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
  //   }

  //   return rangeValues;
  // },
  getRangeValues: () => {
    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");


    //  calling for primary homes  //   estimated market value of all selected secondary properties
    // let step = 500000;
    // for (let i = 1; i <= 18; i++) {
    //   v2 = 1000000 + step * i;
    //   v1 = v2 - step + 1;
    //   rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    // }

    return rangeValues;
  },
  getMarksRangeValues_10M: () => {
    const rangeValues = F.getRangeValues_10M();

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }
    return marks;
  },
  getMarksRangeValues: () => {
    const rangeValues = F.getRangeValues();

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }
    return marks;
  },
  rangeToArray: (range) => {
    if (range !== "") {
      range = range.split("-");
      range[0] = parseInt(range[0].replace(/\$/g, "").replace(/,/g, ""), 10);
      range[1] = parseInt(range[1].replace(/\$/g, "").replace(/,/g, ""), 10);
      return range;
    } else {
      return [0, 0];
    }
  },
  rangeSliderFormatter: (val, marks) => {
    return marks[val].val !== "" ? marks[val].val : "$0";
  },
  sliderValue: (val, marks) => {
    return marks[val].val;
  }
};




// Ant-Ui-Fix for dropdowns
export const getPopupContainer = (trigger) => {
  return trigger && trigger.parentNode ? trigger.parentNode : document.body;
};






export default Functions;



// WEBPACK FOOTER //
// ./src/Functions.js